<p-toast></p-toast>
<div class="container-fluid container-fullw">
  <div class="p-fluid p-grid">
    <div class="p-col-12">
      <div>
        <p-fieldset [toggleable]="true">
          <ng-template pTemplate="header">
            <span *ngIf="ingredient.id === null">{{ 'NEWINGREDIENT' | translate }}</span>
            <span *ngIf="ingredient.id !== null">{{ 'EDITINGREDIENT' | translate }}</span>
          </ng-template>
          <form pFocusTrap name="ingredientForm" id="ingredientForm" novalidate (ngSubmit)="submitForm(true)" [formGroup]="ingredientForm" >
            <input type="hidden" name="id" id="ingredientId" formControlName="id" />
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-tag"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="ingredientName" formControlName="name" type="text" pInputText [required]="true"> 
                      <label for="ingredientName" class="req">{{ 'NAME' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="ingredientForm.controls['name'].invalid && (ingredientForm.controls['name'].dirty || ingredientForm.controls['name'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="ingredientForm.controls['name'].errors !== null">
                  <div *ngIf="ingredientForm.controls['name'].errors.required">
                   {{ 'NAMEREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-marker-alt"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="ingredientNameAr" formControlName="nameAr" type="text" pInputText [required]="false"> 
                      <label for="ingredientNameAr" class="">{{ 'NAMEAR' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-marker-alt"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="ingredientNameFr" formControlName="nameFr" type="text" pInputText [required]="false"> 
                      <label for="ingredientNameFr" class="">{{ 'NAMEFR' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-marker-alt"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="ingredientNameEn" formControlName="nameEn" type="text" pInputText [required]="false"> 
                      <label for="ingredientNameEn" class="">{{ 'NAMEEN' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
           
         
      
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-marker-alt"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="ingredientUnit" formControlName="unit" type="text" pInputText [required]="false"> 
                      <label for="ingredientUnit" class="">{{ 'Unit' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-marker-alt"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="ingredientQuantity" formControlName="quantity" type="text" pInputText [required]="false"> 
                      <label for="ingredientQuantity" class="">{{ 'Quantity' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="far fa-newspaper"></i>
                    </span>
                    <span class="p-float-label">
                      <p-dropdown 
                      inputId="recipeId" 
                      [autoDisplayFirst]="false" 
                      formControlName="recipe" 
                      [options]="recipes" 
                      (onChange)="onChange($event)" 
                      optionLabel="title" 
                      [required]="true" 
                      [filter]="true">
                    </p-dropdown>
                    
                    <label for="recipeId" class="req">recipe</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="ingredientForm.controls['recipe'].invalid && (ingredientForm.controls['recipe'].dirty || ingredientForm.controls['recipe'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="ingredientForm.controls['recipe'].errors !== null">
                  <div *ngIf="ingredientForm.controls['recipe'].errors.required">
                 recipe required
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-image"></i>
                    </span>


                    <input type="file" id="ingredientImagePath" formControlName="imagePath" description="imagePath" pButton pRipple icon="pi pi-folder" styleClass="p-button-info"  class="w-100" (change)="uploadPhoto($event)" accept="image/*" />
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->

            <div class="p-fluid p-grid">
              <div class="p-col-4">
                <button (click)="list()" class="btn btn-primary pull-left">
                  <i class="icon-layout-list-thumb"></i>
                  <span class="p-ml-1">{{ 'BACKINGREDIENTS' | translate }}</span>
                </button>
              </div>
              <div class="p-col-4 text-center">
                <button *ngIf="ingredient.id !== null" type="button" (click)="submitForm(false)" class="btn btn-primary" [disabled]="!ingredientForm.valid || disableSubmit"> <!--  [disabled]="ingredientForm.$invalid" -->
                  <i class="fas fa-spinner fa-spin" *ngIf="disableSubmit && !redirect"></i>
                  <i class="fas fa-check-circle" *ngIf="!(disableSubmit && !redirect)"></i>
                  <span class="p-ml-1"> {{ 'APPLY' | translate }}</span>
                </button>
              </div>
              <div class="p-col-4">
                <button type="button" (click)="submitForm(true)" class="btn btn-primary pull-right" [disabled]="disableSubmit"> <!--  [disabled]="!ingredientForm.valid || " -->
                  <i class="fas fa-spinner fa-spin" *ngIf="disableSubmit && redirect"></i>
                  <i class="icon-save" *ngIf="!(disableSubmit && redirect)"></i>
                  <span class="p-ml-1">{{ 'SAVE' | translate }}</span>
                </button>
              </div>
            </div>
          </form>
        </p-fieldset>
        <div class="p-fluid p-grid">
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
          <div class="col-sm-12 p-col-4 mb-2 text-center">
          </div>
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
        </div>
      </div>
    </div><!--/p-col-12-->
  </div><!--/p-fluid p-grid-->
  <p-scrollTop target="parent"></p-scrollTop>
</div><!--/container-fluid container-fullw-->
<!-- end: FORM -->

